module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("4ffg6"))).then(() => parcelRequire('iDabs'));